import axios from 'axios';

const generateToken = async () => {
  const res = await axios.post('/api_keys.json');
  document.querySelector('.js-token').value = res.data;
  document.querySelector('.js-copy-token').classList.remove('d-none');
};

const copyText = async () => {
  const token = document.querySelector('.js-token');
  token.select();
  token.setSelectionRange(0, 99999);
  document.execCommand('copy');
};

document.addEventListener('turbolinks:load', () => {
  const generateTokenBtn = document.querySelector('.js-generate-token');
  const copyTokenBtn = document.querySelector('.js-copy-token');
  if (generateTokenBtn) {
    generateTokenBtn.addEventListener('click', generateToken);
  }
  if (copyTokenBtn) {
    copyTokenBtn.addEventListener('click', copyText);
  }
});
